import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { IconButton } from '@grnhse/seedling/lib/birch/components/buttons';
import CloseIcon from '@grnhse/seedling/lib/birch/icons/close';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filters.applied');

const MAX_TEXT_LENGTH = 70;

// Strip HTML tags for plain text display in tooltips
const stripHtmlTags = (html: string): string => {
  return html.replace(/<[^>]*>/g, '');
};

// Preserve only <strong> tags while stripping all other HTML tags
const preserveStrongTags = (html: string): string => {
  const withPlaceholders = html
    .replace(/<strong>/g, '___STRONG_OPEN___')
    .replace(/<\/strong>/g, '___STRONG_CLOSE___');

  const stripped = stripHtmlTags(withPlaceholders);

  return stripped
    .replace(/___STRONG_OPEN___/g, '<strong>')
    .replace(/___STRONG_CLOSE___/g, '</strong>');
};

type Props = {
  text?: string | null;
  onRemove: () => void;
};

const ClearableFilter = ({ text, onRemove }: Props) => {
  if (!text) {
    return (
      <IconButton
        icon={CloseIcon}
        label={t('remove')}
        onClick={onRemove}
        size="sm"
        flat
      />
    );
  }

  const isTruncated = stripHtmlTags(text).length > MAX_TEXT_LENGTH;
  const displayText = isTruncated
    ? preserveStrongTags(text.substring(0, MAX_TEXT_LENGTH - 3) + '...')
    : preserveStrongTags(text);

  const tooltipText: string | null = isTruncated ? stripHtmlTags(text) : null;

  return (
    <Stack direction="row" spacing={0}>
      <Tooltip label={tooltipText} ariaLabel={tooltipText || ''}>
        <SecondaryBody
          dangerouslySetInnerHTML={{
            __html: displayText,
          }}
        />
      </Tooltip>
      <IconButton
        icon={CloseIcon}
        label={t('remove')}
        onClick={onRemove}
        size="sm"
        flat
      />
    </Stack>
  );
};

export default ClearableFilter;
